import React from 'react'
import PropTypes from 'prop-types'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import ContentBox from '../../../layout/component/ContentBox'
import {formatDate} from '../../../../util/datetime'
import currentUserHasAccess from '../../../../util/widget-helper'
import {CUSTOMS_INVOICE_LIST_WIDGET} from "../../../process/ui-definition/process-ui";
import {BACKEND_URL} from "../../../../util/api";

const NAME_TREATMENT = 'Treatment';

const CustomsInvoice = ({customsInvoice}) => {
    const downloadUrl = `${BACKEND_URL}/api/file-system/download-file?fileId=${customsInvoice.id}`
    const viewUrl = `${BACKEND_URL}/api/file-system/view-file?fileId=${customsInvoice.id}`

    return (
        <tr>
            <td>{NAME_TREATMENT}</td>
            <td>{formatDate(customsInvoice.created)}</td>
            <td><a href={downloadUrl} download>download</a></td>
            <td><a href={viewUrl} target="_blank" rel="noopener noreferrer">view</a></td>
        </tr>
    )
};

const CustomsInvoiceList = ({customsInvoiceList}) => {
    if (!currentUserHasAccess(CUSTOMS_INVOICE_LIST_WIDGET)) {
        return null
    }

    return (
        <ContentBox title="Customs Invoices ">
            <Row>
                <Column size={12}>
                    <table className="default-table">
                        <thead>
                        <tr>
                            <th>Product</th>
                            <th>Created</th>
                            <th>Download</th>
                            <th>View</th>
                        </tr>
                        </thead>
                        <tbody>
                        {customsInvoiceList.map(customsInvoice => {
                            return <CustomsInvoice customsInvoice={customsInvoice}
                                                   key={`customs-invoice-${customsInvoice.id}`}/>
                        })}
                        </tbody>
                    </table>
                </Column>
            </Row>
        </ContentBox>
    )
}

CustomsInvoiceList.propTypes = {
    customsInvoiceList: PropTypes.array.isRequired,
}

export default CustomsInvoiceList




// WEBPACK FOOTER //
// ./src/modules/invoice/component/list/CustomsInvoiceList.js